/**
 * One rendering of "who did this" for audit rows, shared by the Settings →
 * Audit log tab, the per-record History tab and the CSV export, so an
 * impersonated write reads identically everywhere: the accountable admin
 * first, then the person they were viewing as.
 */
export function actorLabel(row: {
  actorName: string | null;
  impersonatedName: string | null;
}): string {
  const actor = row.actorName ?? "System";
  return row.impersonatedName ? `${actor} (as ${row.impersonatedName})` : actor;
}
